import React, { useEffect, useRef } from "react";
import { FaAngleDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function SubMenu({ open, toggle, icon: Icon, label, items }) {
  const menuRef = useRef(null);

  // Fecha submenu ao clicar fora
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        if (open) toggle();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, toggle]);

  return (
    <div className="relative" ref={menuRef}>
      {/* Botão principal do submenu */}
      <button
        onClick={toggle}
        className="group flex items-center gap-2 px-3 py-1 transition-all duration-300 transform hover:scale-105 hover:shadow-lg text-sm font-medium text-white"
      >
        <Icon className="text-sm transition-transform group-hover:scale-110" />
        <span className="font-medium text-sm">{label}</span>
        <FaAngleDown
          className={`transition-transform duration-300 text-sm ${open ? "rotate-180" : ""}`}
        />
      </button>

      {/* Itens do submenu com animação */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="absolute bg-[#f95000] mt-1 shadow-2xl w-56 z-50 left-0 top-full border border-black/10 backdrop-blur-sm overflow-hidden"
          >
            <div className="p-1 space-y-1 text-sm">
              {items.map(({ to, label, icon: ItemIcon }, i) => (
                <Link
                  key={i}
                  to={to}
                  onClick={toggle}
                  className="flex items-center gap-2 px-3 py-1 text-white font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-lg group"
                >
                  <ItemIcon className="text-sm group-hover:scale-110 transition-transform" />
                  <span className="font-medium text-sm">{label}</span>
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
